import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { LANDING_CONTENT as C } from '../components/landing/landingContent';
import { API_BASE } from '../services/api';

export default function BlogListPage() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const pageSize = 9;

  useEffect(() => {
    setLoading(true);
    fetch(`${API_BASE}/api/blog?page=${page}&page_size=${pageSize}`)
      .then((r) => r.json())
      .then((data) => {
        setPosts(data.posts || []);
        setTotal(data.total || 0);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [page]);

  const totalPages = Math.max(1, Math.ceil(total / pageSize));

  return (
    <div className="blp-page">
      <style>{CSS}</style>
      <header className="blp-header">
        <Link to="/" className="blp-brand">{C.brand.name}</Link>
        <Link to="/" className="blp-back">← Back to Home</Link>
      </header>

      <div className="blp-hero">
        <h1 className="blp-hero-title">Blog</h1>
        <p className="blp-hero-sub">Insights, updates, and stories from our team.</p>
      </div>

      <div className="blp-content">
        {loading ? (
          <div className="blp-loading">Loading posts...</div>
        ) : posts.length === 0 ? (
          <div className="blp-empty">No posts published yet — check back soon.</div>
        ) : (
          <>
            <div className="blp-grid">
              {posts.map((post) => (
                <Link to={`/blog/${post.slug}`} key={post.id} className="blp-card">
                  {post.cover_image_url && (
                    <div className="blp-card-image" style={{ backgroundImage: `url(${post.cover_image_url})` }} />
                  )}
                  <div className="blp-card-body">
                    <h2 className="blp-card-title">{post.title}</h2>
                    {post.excerpt && <p className="blp-card-excerpt">{post.excerpt}</p>}
                    <span className="blp-card-date">
                      {post.published_at ? new Date(post.published_at).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' }) : ''}
                    </span>
                  </div>
                </Link>
              ))}
            </div>

            {totalPages > 1 && (
              <div className="blp-pagination">
                <button disabled={page <= 1} onClick={() => setPage((p) => p - 1)} className="blp-page-btn">Previous</button>
                <span className="blp-page-info">Page {page} of {totalPages}</span>
                <button disabled={page >= totalPages} onClick={() => setPage((p) => p + 1)} className="blp-page-btn">Next</button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

const CSS = `
.blp-page { min-height: 100vh; background: var(--bg-primary, #0b0f1a); color: var(--text-primary, #e2e8f0); }
.blp-header { display: flex; align-items: center; justify-content: space-between; padding: 20px 32px; border-bottom: 1px solid rgba(255,255,255,0.08); }
.blp-brand { font-size: 16px; font-weight: 800; color: var(--text-primary, #e2e8f0); text-decoration: none; }
.blp-back { font-size: 13px; color: var(--text-muted, #94a3b8); text-decoration: none; }
.blp-back:hover { color: #a5b4fc; }

.blp-hero { text-align: center; padding: 56px 24px 32px; }
.blp-hero-title { font-size: 40px; font-weight: 800; margin: 0 0 10px; }
.blp-hero-sub { font-size: 15px; color: var(--text-muted, #94a3b8); margin: 0; }

.blp-content { max-width: 1100px; margin: 0 auto; padding: 0 24px 80px; }
.blp-loading, .blp-empty { text-align: center; padding: 80px 0; color: var(--text-muted, #94a3b8); font-size: 14px; }

.blp-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(300px, 1fr)); gap: 24px; }
.blp-card {
  display: block; text-decoration: none; color: inherit; border-radius: 14px; overflow: hidden;
  background: rgba(30,41,59,0.5); border: 1px solid rgba(255,255,255,0.08); transition: transform 0.15s, box-shadow 0.15s;
}
[data-theme="light"] .blp-card { background: #fff; border-color: rgba(99,102,241,0.1); box-shadow: 0 2px 8px rgba(0,0,0,0.04); }
.blp-card:hover { transform: translateY(-3px); box-shadow: 0 12px 24px rgba(0,0,0,0.2); }
.blp-card-image { width: 100%; height: 170px; background-size: cover; background-position: center; }
.blp-card-body { padding: 18px 20px; }
.blp-card-title { font-size: 17px; font-weight: 700; margin: 0 0 8px; line-height: 1.3; }
.blp-card-excerpt { font-size: 13px; color: var(--text-muted, #94a3b8); margin: 0 0 12px; line-height: 1.5; display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden; }
.blp-card-date { font-size: 11px; color: var(--text-muted, #94a3b8); font-weight: 600; }

.blp-pagination { display: flex; align-items: center; justify-content: center; gap: 16px; margin-top: 40px; }
.blp-page-btn { padding: 8px 18px; border-radius: 8px; font-size: 13px; font-weight: 600; cursor: pointer; background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.12); color: var(--text-primary, #e2e8f0); }
.blp-page-btn:disabled { opacity: 0.4; cursor: not-allowed; }
.blp-page-info { font-size: 13px; color: var(--text-muted, #94a3b8); }
`;
